import React from "react";
import { format } from "date-fns";

export interface DateRenderProps {
  date: string | Date | number;
  format?: string;
}

export function DateRender(props: DateRenderProps) {
  return <>{format(new Date(props.date), props.format || "yyyy-MM-dd HH:mm:ss")}</>;
}
